import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { Components_Chip_51BC9844, ComponentsModule_Chip_Level } from "../Components/Chip.js";
import { Tickets_toLocalizedType, Tickets_toLocalizedSegment, Tickets_severity } from "../Locale.js";
import { hierarchyContext } from "../CompanyHierarchyContext.js";
import { useResponsive } from "../Utils.js";
import { Array_distinctBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { map, append, contains, collect, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { createObj, safeHash, equals, numberHash } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Message } from "./TicketCenterModel.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Slider, FormGroup, Checkbox, FormControlLabel, MenuItem, TextField, IconButton, Skeleton, Typography } from "@mui/material";
import { empty, append as append_1, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import FilterList from "@mui/icons-material/FilterList";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import Close from "@mui/icons-material/Close";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { value as value_193, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Tickets_Segment_All, Tickets_TicketType_All, Tickets_TicketStatus_All, Tickets_Severity, Tickets_Severity_All } from "../Shared/Shared.js";
import { Tickets_StatusChip_Z17F2D702 } from "../Components/Tickets/StatusChip.js";

function Tickets_SeverityChip_E4CA5D4(tickets_SeverityChip_E4CA5D4InputProps) {
    const onEnable = tickets_SeverityChip_E4CA5D4InputProps.onEnable;
    const enabled = tickets_SeverityChip_E4CA5D4InputProps.enabled;
    const severity = tickets_SeverityChip_E4CA5D4InputProps.severity;
    const ctx = reactApi.useContext(ctx_1);
    const colorLevel = (severity.tag === 1) ? (new ComponentsModule_Chip_Level(4, [])) : ((severity.tag === 2) ? (new ComponentsModule_Chip_Level(4, [])) : ((severity.tag === 3) ? (new ComponentsModule_Chip_Level(3, [])) : ((severity.tag === 4) ? (new ComponentsModule_Chip_Level(2, [])) : ((severity.tag === 5) ? (new ComponentsModule_Chip_Level(5, [])) : (new ComponentsModule_Chip_Level(4, []))))));
    return createElement(Components_Chip_51BC9844, {
        key: "",
        $key: "",
        primary: Tickets_severity(ctx.Locale, severity),
        enabled: enabled,
        onClick: () => {
            onEnable();
        },
        colorLevel: colorLevel,
    });
}

function Tickets_SegmentChip_ZD28225C(tickets_SegmentChip_ZD28225CInputProps) {
    const onEnable = tickets_SegmentChip_ZD28225CInputProps.onEnable;
    const enabled = tickets_SegmentChip_ZD28225CInputProps.enabled;
    const segment = tickets_SegmentChip_ZD28225CInputProps.segment;
    const ctx = reactApi.useContext(ctx_1);
    return createElement(Components_Chip_51BC9844, {
        key: "",
        $key: "",
        primary: Tickets_toLocalizedSegment(ctx.Locale, segment),
        enabled: enabled,
        onClick: () => {
            onEnable();
        },
        colorLevel: new ComponentsModule_Chip_Level(5, []),
    });
}

export function Tickets_FilterBar_7DEF20C1(tickets_FilterBar_7DEF20C1InputProps) {
    let elems_18;
    const dispatch = tickets_FilterBar_7DEF20C1InputProps.dispatch;
    const filter = tickets_FilterBar_7DEF20C1InputProps.filter;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const responsive = useResponsive(undefined);
    let patternInput;
    const initial = [0, 12];
    patternInput = reactApi.useState(initial);
    const companies = Array_distinctBy((_arg) => _arg.Id, choose((group) => group.Company, hierarchy.Groups), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    });
    const departments = collect((company) => {
        if (equals(company.Id, filter.SelectedCompany)) {
            return company.Departments;
        }
        else {
            return [];
        }
    }, companies);
    const toggleSeverity = (severity) => {
        dispatch(new Message(7, [contains(severity, filter.SelectedSeverities, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? filter.SelectedSeverities.filter((current_1) => !equals(current_1, severity)) : append(filter.SelectedSeverities, [severity])]));
    };
    const title = (text) => MuiHelpers_createElement(Typography, [["variant", "h5"], ["sx", {
        lineHeight: 25.6 + "px",
    }], ["children", createElement("b", {
        children: [text],
    })]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        height: 100 + "%",
        padding: ((((((30 + "px ") + 30) + "px ") + 30) + "px ") + 30) + "px",
        backgroundColor: "white",
        borderRadius: 15 + "px",
        gap: 5 + "px ",
    }], (elems_18 = toList(delay(() => {
        let elems_1;
        return !hierarchy.GroupsFetched ? singleton(MuiHelpers_createElement(Skeleton, [["width", 100 + "%"], ["height", 100 + "%"]])) : append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems_1 = toList(delay(() => {
            let elems, props_6;
            return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 10 + "px",
                flexGrow: 1,
            }], (elems = [(props_6 = {}, react.createElement(FilterList, props_6)), MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Filter")]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let props_10;
                const matchValue = responsive;
                switch (matchValue) {
                    case "desktop":
                    case "wideScreen":
                        return singleton(defaultOf());
                    default:
                        return singleton(MuiHelpers_createElement(IconButton, [["onClick", (_arg_2) => {
                            dispatch(new Message(12, [false]));
                        }], ["children", (props_10 = {}, react.createElement(Close, props_10))]]));
                }
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_17, elems_3, elems_2, elems_5, elems_4, elems_6, elems_8, elems_7, array_22, elems_10, elems_9, elems_12, elements, elems_14, elems_13, elems_16, elems_15;
            return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["filter-bar-controllers-container"])], (elems_17 = [createElement("div", createObj(singleton_1((elems_3 = [MuiHelpers_createElement(TextField, [["size", "small"], ["fullWidth", true], ["select", true], ["label", ctx.Locale.t("Ticket.LegalEntity")], ["value", defaultArg(filter.SelectedCompany, -1)], ["onChange", (ev) => {
                const target = ev.target;
                console.debug("[FilterBar] Change company: %i", target.value);
                dispatch(new Message(4, [(target.value < 0) ? undefined : target.value]));
                dispatch(new Message(5, [undefined]));
            }], (elems_2 = [MuiHelpers_createElement(MenuItem, [["value", -1], ["children", "Alle"]]), map((company_1) => MuiHelpers_createElement(MenuItem, [["value", company_1.Id], ["children", company_1.Name]]), companies)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
            }], (elems_5 = [MuiHelpers_createElement(TextField, [["size", "small"], ["sx", {
                flexGrow: 1,
            }], ["disabled", filter.SelectedCompany == null], ["select", true], ["label", ctx.Locale.t("Department")], ["value", defaultArg(filter.SelectedDepartment, -1)], ["onChange", (ev_1) => {
                const target_1 = ev_1.target;
                console.debug("[FilterBar] Change department: %i", target_1.value);
                dispatch(new Message(5, [(target_1.value < 0) ? undefined : target_1.value]));
            }], (elems_4 = [MuiHelpers_createElement(MenuItem, [["value", -1], ["children", "Alle"]]), map((department) => MuiHelpers_createElement(MenuItem, [["value", department.Id], ["children", department.Name]]), departments)], ["children", reactApi.Children.toArray(Array.from(elems_4))])])], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), MuiHelpers_createElement(FormControlLabel, [["label", [createElement("div", createObj(ofArray([["key", "my-tickets-only-checkbox"], ["style", {
                display: "flex",
                alignItems: "center",
                gap: 5 + "px ",
            }], (elems_6 = [ctx.Locale.t("TicketList.MyTicketsOnly")], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))]], ["checked", filter.ResponsibleOnly], ["onChange", (ev_2) => {
                dispatch(new Message(14, [!filter.ResponsibleOnly]));
                console.debug("[Ticket center] Responsible only onChange");
            }], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["size", "small"]])]]), createElement("div", createObj(singleton_1((elems_8 = [title(ctx.Locale.t("Ticket.Severity.Severity")), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "flex-start",
                gap: 5 + "px",
            }], (elems_7 = [map((severity_1) => {
                const enabled_1 = contains(severity_1, filter.SelectedSeverities, {
                    Equals: equals,
                    GetHashCode: safeHash,
                });
                return createElement(Tickets_SeverityChip_E4CA5D4, {
                    severity: severity_1,
                    enabled: enabled_1,
                    onEnable: () => {
                        toggleSeverity(severity_1);
                    },
                });
            }, (array_22 = Tickets_Severity_All(), array_22.filter((sev) => !equals(sev, new Tickets_Severity(5, []))))), createElement(Tickets_SeverityChip_E4CA5D4, {
                severity: new Tickets_Severity(0, []),
                enabled: contains(new Tickets_Severity(0, []), filter.SelectedSeverities, {
                    Equals: equals,
                    GetHashCode: safeHash,
                }),
                onEnable: () => {
                    toggleSeverity(new Tickets_Severity(0, []));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 10 + "px",
            }], (elems_10 = [title("Status"), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "flex-start",
                gap: 5 + "px",
            }], (elems_9 = map((status_1) => {
                const enabled_2 = contains(status_1, filter.SelectedStatus, {
                    Equals: equals,
                    GetHashCode: safeHash,
                });
                return createElement(Tickets_StatusChip_Z17F2D702, {
                    status: status_1,
                    enabled: enabled_2,
                    onEnable: () => {
                        const status = status_1;
                        dispatch(new Message(8, [contains(status, filter.SelectedStatus, {
                            Equals: equals,
                            GetHashCode: safeHash,
                        }) ? filter.SelectedStatus.filter((current_2) => {
                            console.debug("[Ticket center] Toggle status", current_2, "vs", status);
                            return !equals(current_2, status);
                        }) : append(filter.SelectedStatus, [status])]));
                    },
                });
            }, Tickets_TicketStatus_All()), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
                switch (responsive) {
                    case "desktop":
                    case "wideScreen":
                        return singleton(["maxWidth", 20 + "ch"]);
                    default: {
                        return empty();
                    }
                }
            })))], (elems_12 = [title("Tickettype"), MuiHelpers_createElement(FormGroup, [(elements = map((ticketType_1) => {
                let typography, x_6;
                const label = Tickets_toLocalizedType(ctx.Locale, ticketType_1);
                const enabled = contains(ticketType_1, filter.SelectedTypes, {
                    Equals: equals,
                    GetHashCode: safeHash,
                });
                return MuiHelpers_createElement(FormControlLabel, [["title", label], ["classes.label", "text-overflow"], (typography = [["sx", createObj(toList(delay(() => {
                    switch (responsive) {
                        case "desktop":
                        case "wideScreen":
                            return singleton(["maxWidth", 20 + "ch"]);
                        default: {
                            return empty();
                        }
                    }
                })))]], ["slotProps", (x_6 = {}, ((typography != null) ? (x_6.typography = createObj(value_193(typography))) : undefined, x_6))]), ["label", label], ["onChange", (e) => {
                    const _arg_1 = e.target.checked;
                    const ticketType = ticketType_1;
                    dispatch(new Message(9, [contains(ticketType, filter.SelectedTypes, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    }) ? filter.SelectedTypes.filter((current_3) => !equals(current_3, ticketType)) : append(filter.SelectedTypes, [ticketType])]));
                }], ["checked", enabled], ["control", MuiHelpers_createElement(Checkbox, [["size", "small"]])]]);
            }, Tickets_TicketType_All()), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), createElement("div", createObj(singleton_1((elems_14 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
            }], (elems_13 = [title(ctx.Locale.t("Ticket.TicketAge")), MuiHelpers_createElement(Checkbox, [["size", "small"], ["sx", {
                p: 0.5,
            }], ["disabled", true], ["checked", true]])], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))), createElement("div", {
                style: {
                    padding: ((((((0 + "px") + " ") + (30 + "px")) + " ") + (0 + "px")) + " ") + (30 + "px"),
                },
                children: MuiHelpers_createElement(Slider, [["min", 0], ["max", 12], ["size", "medium"], ["disabled", true], ["valueLabelDisplay", "auto"], ["onChange", (delegateArg, delegateArg_1) => {
                    patternInput[1](delegateArg_1);
                }], ["value", patternInput[0]], ["marks", [{
                    label: ctx.Locale.t("Ticket.0Days"),
                    value: 0,
                }, {
                    label: ctx.Locale.t("Ticket.Maks"),
                    value: 12,
                }]]]),
            })], ["children", reactApi.Children.toArray(Array.from(elems_14))])))), createElement("div", createObj(singleton_1((elems_16 = [title(ctx.Locale.t("Ticket.Segment.Segment")), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                gap: 5 + "px",
            }], (elems_15 = map((segment_1) => {
                const enabled_3 = contains(segment_1, filter.SelectedSegments, {
                    Equals: equals,
                    GetHashCode: safeHash,
                });
                return createElement(Tickets_SegmentChip_ZD28225C, {
                    segment: segment_1,
                    enabled: enabled_3,
                    onEnable: () => {
                        const segment = segment_1;
                        dispatch(new Message(6, [contains(segment, filter.SelectedSegments, {
                            Equals: equals,
                            GetHashCode: safeHash,
                        }) ? filter.SelectedSegments.filter((current) => {
                            console.debug("[Ticket center] Toggle segment", current, "vs", segment);
                            return !equals(current, segment);
                        }) : append(filter.SelectedSegments, [segment])]));
                    },
                });
            }, Tickets_Segment_All()), ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))]))))], ["children", reactApi.Children.toArray(Array.from(elems_17))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_18))])])));
}

